import React from 'react';
import classNames from 'classnames';
import { upperFirst } from 'lodash';
import PropTypes from 'prop-types';
import css from './BriefGeneratorButton.css';
import { Button } from '../../../../components/widgets';

const BriefGeneratorButton = ({ onBriefGenerator, buttonClassName, generatorKey = '', isActive = false }) => (
    <Button
        onClick={() => onBriefGenerator(generatorKey)}
        variant="tertiary"
        size="small"
        type="secondary"
        level="level2"
        Icon="pencil-2-ai-line"
        iconClass={isActive ? css.activeBriefIcon : ''}
        className={classNames(buttonClassName ?? buttonClassName, {
            [css.activeBrief]: isActive,
        })}
        text={generatorKey ? `${upperFirst(generatorKey)} Brief` : 'Brief Generator'}
    />
);

BriefGeneratorButton.propTypes = {
    onBriefGenerator: PropTypes.func,
    generatorKey: PropTypes.string,
    isActive: PropTypes.bool,
    buttonClassName: PropTypes.string,
};

export default BriefGeneratorButton;
